import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type BvFlashService from 'volta/services/bv-flash';

export default class BvFlashContainer extends Component {
  @service declare bvFlash: BvFlashService;
}
